module.exports = __webpack_public_path__ + "img/icon_share_b.7863a39e.svg";